/**
 * Permission codes the operating-calendar screens declare an interest in
 * (`internal/core/opcal/permissions.go`, design §6.1).
 *
 * `opcal.day.reopen` is separate from `opcal.day.close` and carries step-up MFA
 * server-side, for the reason §7.3 gives: reopening a closed day reopens a
 * *record* somebody already certified. Closing is routine and belongs to whoever
 * runs the unit; reopening is an exception and belongs to whoever answers for it.
 */

export const OPCAL_PERMISSIONS = {
  calendarRead: 'opcal.calendar.read',
  calendarManage: 'opcal.calendar.manage',

  dayRead: 'opcal.day.read',
  dayOpen: 'opcal.day.open',
  dayClose: 'opcal.day.close',
  /** Step-up MFA server-side, and dual-authorised. */
  dayReopen: 'opcal.day.reopen',

  /** Read reason codes to fill the force-close and reopen pickers. */
  reasonCodeRead: 'rules.reason.read',
  /** Read companies to pick the board's company. */
  companyRead: 'org.company.read',
} as const

export type OpcalPermission = (typeof OPCAL_PERMISSIONS)[keyof typeof OPCAL_PERMISSIONS]
